export const FEATURED_ACTIVITY_DEFINITION_MODULE_URL =
  'volunteer/featured-activity-definitions';
